<template>
	<div class="home">
		<div class="main-panel">
			<div class="content">
				<div class="panel-header bg-primary-gradient">
					<div class="page-inner py-5">
                        <div class="row">
                            <div class="col-md-4">
                                <h2 class="text-white pb-2 fw-bold">Data Laporan Gizi</h2>
                                <!-- <h5 class="text-white op-7 mb-2">Jumlah Penduduk : 310988 / Konsumsi Kg/Kap/Th : 98.6 </h5> -->
                            </div>
                            <div class="col-md-4">
                                <!-- <select @change="getPuskesmas()" class="form-control" v-model="form.master_komoditi_id">
                                    <option v-for="data in list_puskesmas" :key="data.master_komoditi_id" :value="data.master_komoditi_id">Data Produksi {{data.uraian}}</option>
                                </select>
                                <br> -->
                            </div>
                            <div class="col-md-4">
                                
                                    <select @change="getTahun()" class="form-control" v-model="form.thn">
                                        <option v-for="data in list_thn" :key="data.id" :value="data.id">{{data.tahun}}</option>
                                    </select>
                                <br>
                            </div>
                          
                        </div>
					</div>
				</div>

<!-- <h1>TES1</h1>


<pdf src="https://crossorigin.me/http://36.89.95.163:5100/uploads/peraturan/1564543467109.pdf"></pdf>
<h1>TES2</h1> -->

				<div class="page-inner mt--5">
					<!-- <h1>asdfad</h1> -->
					<div class="table-responsive" style="background:white; overflow-x:auto;">
                        <table class="table-kiken table table-head-bg-info" width="100%" >
							<thead>
                                <tr class="bg-primary text-center">
									<th scope="col" style="width: 5%">No</th>
                                    <th scope="col" style="width: 18%">Puskesmas</th>
									<th scope="col" style="width: 9%">Jumlah Balita</th>
                                    <th scope="col" style="width: 9%">Jml Balita Yang <br>Terdaftar dan <br>memiliki KMS</th>
                                    <th scope="col" style="width: 9%">Datang <br>Ditimbang</th>
                                    <th scope="col" style="width: 9%">Jumlah <br>Balita Naik BB</th>
                                    <th scope="col" style="width: 9%">Tidak Naik <br>Bbnya (2T)</th>
                                    <th scope="col" style="width: 9%">BGM</th>
                                    <th scope="col" style="width: 9%">Gz Buruk <br>(BB/U)</th>
                                    <th scope="col" style="width: 9%">Gz Kurang <br>(BB/U)</th>
                                    <th scope="col" style="width: 5%">#</th>      
								</tr>
							</thead>
							<tbody>
								<tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{data.puskesmas}}</td>
                                    <td>{{data.jml_balita}}</td>
                                    <td>{{data.jml_balita_terdaftar_kms}}</td>
                                    <td>{{data.datang_ditimbang}}</td>
                                    <td>{{data.jml_balita_naik_bb}}</td>
                                    <td>{{data.jml_balita_tdk_naik_bb}}</td>
                                    <td>{{data.bgm}}</td>
                                    <td>{{data.gz_buruk}}</td>
                                    <td>{{data.gz_kurang}}</td>
                                    <td class="text-center">
                                        <button v-if="Chk_Add(data)" @click="selectDataAdd(data)" class="btn btn-info btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_add_data"><i class="fas fa-plus"></i></button>
                                        <!-- &nbsp; -->
                                        <button v-if="!Chk_Add(data)" @click="selectData(data)" class="btn btn-warning btn-icon btn-round btn-xs" title="Edit Data" data-toggle="modal" data-target="#m_edit_data"><i class="fas fa-pencil-alt"></i></button>
                                    </td>
								</tr>

							</tbody>
						</table>

                       
					</div>
				</div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-info">
                                    <h5 class="modal-title">TAMBAH DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="addData()">
                                    <div class="modal-body">
                                        <div>
                                            <!-- <span class="huruf_input">Puskesmas</span>
                                            <select class="form-control form-control-sm" v-model="form.master_puskesmas_id">
                                                <option v-for="data in list_puskesmas" :key="data.id" :value="data.id">{{data.puskesmas}}</option>
                                            </select>
                                            <br> -->

                                            <span class="huruf_input">Jumlah Balita</span>
                                            <input v-model="form.jml_balita" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Jml Balita Yang Terdaftar dan memiliki KMS</span>
                                            <input v-model="form.jml_balita_terdaftar_kms" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Datang Ditimbang</span>
                                            <input v-model="form.datang_ditimbang" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Jumlah  Balita Naik BB</span>
                                            <input v-model="form.jml_balita_naik_bb" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Tidak Naik Bbnya (2T)</span>
                                            <input v-model="form.jml_balita_tdk_naik_bb" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">BGM</span>
                                            <input v-model="form.bgm" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Gz Buruk (BB/U)</span>
                                            <input v-model="form.gz_buruk" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Gz Kurang (BB/U)</span>
                                            <input v-model="form.gz_kurang" class="form-control form-control-sm" type="number"  step="0.01"> <br>
                                        
                                            <span class="huruf_input">Keterangan</span>
                                            <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-info btn-md">Simpan</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bgcol-warning">
                                    <h5 class="modal-title">ATUR DATA</h5>
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <form @submit.prevent="editData()">
                                    <div class="modal-body">
                                        <div>
                                            <!-- <span class="huruf_input">Puskesmas</span>
                                            <select class="form-control form-control-sm" v-model="form.master_puskesmas_id">
                                                <option v-for="data in list_puskesmas" :key="data.id" :value="data.id">{{data.puskesmas}}</option>
                                            </select>
                                            <br> -->

                                            <span class="huruf_input">Jumlah Balita</span>
                                            <input v-model="form.jml_balita" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Jml Balita Yang Terdaftar dan memiliki KMS</span>
                                            <input v-model="form.jml_balita_terdaftar_kms" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Datang Ditimbang</span>
                                            <input v-model="form.datang_ditimbang" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Jumlah  Balita Naik BB</span>
                                            <input v-model="form.jml_balita_naik_bb" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Tidak Naik Bbnya (2T)</span>
                                            <input v-model="form.jml_balita_tdk_naik_bb" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">BGM</span>
                                            <input v-model="form.bgm" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Gz Buruk (BB/U)</span>
                                            <input v-model="form.gz_buruk" class="form-control form-control-sm" type="number"  step="0.01"> <br>

                                            <span class="huruf_input">Gz Kurang (BB/U)</span>
                                            <input v-model="form.gz_kurang" class="form-control form-control-sm" type="number"  step="0.01"> <br>
                                        
                                            <span class="huruf_input">Keterangan</span>
                                            <textarea v-model="form.keterangan" class="form-control form-control-sm"></textarea>
                                            <br>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn bgcol-warning btn-md">Edit</button>
                                        <button @click="emptyData()" type="button" class="btn bgcol-danger btn-md" data-dismiss="modal">Batal</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT DATA xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



			</div>


		<!-- Footer -->
			<foother></foother>
			<!-- End Footer -->


		</div>
	</div>
</template>

<script>



const ADD_URL = URL_APP + "api/v1/statistik_ketapang_data_gizi/";
const ADD_URL_PUSKESMAS = URL_APP + "api/v1/statistik_ketapang_master_puskesmas/";
const ADD_URL_DATE = URL_APP + "api/v1/statistik_ketapang_master_thn_bln/";
const FILE_LOAD = URL_APP + "uploads/";
const URL_SERVER = URL_APP;

import Autocomplete from 'vue2-autocomplete-js';

export default {
    components: { Autocomplete },
    data() {
        return {
            data_load : false,
            form : {
                id : '',
                master_puskesmas_id : '',
                thn : '',
                jml_balita : 0,
                jml_balita_terdaftar_kms : 0,
                datang_ditimbang : 0,
                jml_balita_naik_bb : 0,
                jml_balita_tdk_naik_bb : 0,
                bgm : 0,
                gz_buruk : 0,
                gz_kurang : 0,
                keterangan : ''
            },
            id :'',
            cek_load_data : true,
            cek_edit : false,
            cek_tambah : false,
            cek_Add : false,
            cek_disabled : false,
            file_old: "",
            file_path: FILE_LOAD,

            list_data: [],
            list_thn: [],
            list_bln: [],
            list_puskesmas: [],
            


            page_first: 1,
            page_last: 0,
            cari_value: "",

            URL : URL_SERVER,
            token : localStorage.token,
        }
    },
    methods: {
        getView: function() {

            this.cek_load_data = true;
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                    thn: this.form.thn,
                })
            })
                .then(res => res.json())
                .then(res_data => {
                    console.log(res_data);
                    this.list_data = res_data;
                    this.cek_load_data = false;



            });
        },

        addData: function() {
            fetch(ADD_URL + "addData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
            
        },

        editData: function() {

            fetch(ADD_URL + "editData", {
                method: "POST",
                headers: {
                    'content-type' : 'application/json',
                    authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify(this.form)
            }).then(res_data => {
                this.alertku("success", "Sukses merubah data");
                this.getView();
            });
        },

        selectData: function(data) {
            // console.log(data)
            this.form = {
                id : data.id,
                master_puskesmas_id : data.id_master_puskesmas,
                thn : data.thn,
                jml_balita : data.jml_balita,
                jml_balita_terdaftar_kms : data.jml_balita_terdaftar_kms,
                datang_ditimbang : data.datang_ditimbang,
                jml_balita_naik_bb : data.jml_balita_naik_bb,
                jml_balita_tdk_naik_bb : data.jml_balita_tdk_naik_bb,
                bgm : data.bgm,
                gz_buruk : data.gz_buruk,
                gz_kurang : data.gz_kurang,
                keterangan : data.keterangan

            };

            console.log(data)
            this.cek_edit = true;
            this.cek_tambah = true;
        },
        selectDataAdd: function(data) {


                this.form.master_puskesmas_id = data.id_master_puskesmas;
                this.form.jml_balita = 0;
                this.form.jml_balita_terdaftar_kms = 0;
                this.form.datang_ditimbang = 0;
                this.form.jml_balita_naik_bb = 0;
                this.form.jml_balita_tdk_naik_bb = 0;
                this.form.bgm = 0;
                this.form.gz_buruk = 0;
                this.form.gz_kurang = 0;
        
          

            console.log(data)
            this.cek_edit = true;
            this.cek_tambah = true;
        },

        emptyData : function(){
            this.cek_edit = false;
            this.cek_tambah = false;
        },

        Chk_Add : function(data){
            if (data.jml_balita == null || data.jml_balita == undefined) {
                // console.log('kosong')
                return true;
            } 
            else {
                return false;
            }
            
        },

        removeData: function(idnya) {
            fetch(ADD_URL + "removeData", {
                method: "POST",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                    body: JSON.stringify({
                    id: idnya,
                })
            }).then(res_data => {
                this.getView();
                this.alertku("success", "sukses menghapus data");
                this.fileku = null;
            });
        },
        ke_alamat : function(data){
            window.open(data);
        },

    // ================== TAMBAHAN ====================

        getPuskesmas : function(){
            fetch(ADD_URL_PUSKESMAS, {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                // console.log(res_data)
                this.list_puskesmas = res_data;
                // this.form.master_komoditi_id = res_data[0].master_komoditi_id;
                this.getTahun();
            });
        },
        getTahun : function(){
            fetch(ADD_URL_DATE + "thn", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {

                 this.list_thn = res_data;
                 this.getBln();
            });
        },
        getBln : function(){
            fetch(ADD_URL_DATE + "bln", {
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                }            
            })
            .then(res => res.json())
            .then(res_data => {
                 this.list_bln = res_data;
                 this.getView();
            });
        },
        pembulatan : function(a, b){
            var data = a * b/100;
            var hasil = data.toFixed(2);
            return hasil;
        },
        pembulatanX : function(a, b){
            var data = a * b/100;
            return data;
        },
    // ================== TAMBAHAN ====================

    // ================== AUTOCOMPLETE ====================
        renderChild(data) {
            return `
            <span><b>${data.nama_kecamatan}</b></span>
            <span style='font-size:80%'>${data.nama_kabupaten}</span>
            `
        },
        getAuto : function(obj){
            this.form.kecamatan_id = obj.kecamatan_id;
            this.getView();
            // console.log(obj);
        },
    // ================== AUTOCOMPLETE ====================


    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev : function(){
                this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){

            this.page_first = 1;
            this.getView();
        },

        onFileSelected: function(event) {
            this.form.file = event.target.files[0];
        },
        convert_tgl: function(dateString) {
            var date = new Date(dateString);
            var getBulan = date.getMonth() + 1; var bulan = '';
            if (getBulan == '1') {bulan = 'Jan'} 
            else if(getBulan == '2') {bulan = 'Feb'}
            else if(getBulan == '3') {bulan = 'Mar'}
            else if(getBulan == '4') {bulan = 'Apr'}
            else if(getBulan == '5') {bulan = 'Mei'}
            else if(getBulan == '6') {bulan = 'Jun'}
            else if(getBulan == '7') {bulan = 'Jul'}
            else if(getBulan == '8') {bulan = 'Agt'}
            else if(getBulan == '9') {bulan = 'Sep'}
            else if(getBulan == '10') {bulan = 'Okt'}
            else if(getBulan == '11') {bulan = 'Nov'}
            else if(getBulan == '12') {bulan = 'Des'}

            return date.getDate() + " " + bulan + " " + date.getFullYear();
            // return bulan+ " " + date.getDate() + ". " + date.getFullYear();
        }
    // ================== PAGINASI ====================
        
    },
    mounted() {
        var get_profile = JSON.parse(localStorage.profile);
        // this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
        this.form.unit_kerja = get_profile.profile.unit_kerja;


        this.getPuskesmas();
        

        

        var d = new Date();
        // console.log(d.getMonth())
        this.form.thn = d.getFullYear();
        this.form.bln = d.getMonth();


    },

}
</script>